<div class="crud-editor-div">
    <mat-card>
        <mat-card-title>Acknowledge Ammunition {{eventType}}</mat-card-title>
        <mat-card-content>
            
            <div *ngIf="isAcknowledgeAmmunitionIssueReturnEnabled()">
                <div class="crud-item-section">
                    <button mat-raised-button color="primary" (click)="acknowledgeAmmunitionIssueReturn()">Acknowledge Ammunition {{eventType}}</button>
                </div>
            </div>

            <div *ngIf="acknowledged">
                <div class="crud-item-section">
                    <span class="crud-editor-info">Ammunition {{eventType}} successfully acknowleged.</span>
                </div>
            </div>
            <div *ngIf="error">
                <div class="crud-item-section">
                    <h1 class="crud-editor-warning">Ammunition {{eventType}} acknowledgement failed.</h1>
                </div>
                <div>
                    <h2>{{error.title}}</h2>
                </div>
                <div>
                    <span>{{error.message}}</span>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>